const translations = {
  general: {
    documentTitle: 'Occasions zoeken',
  },
  compare: {
    back: 'Terug',
    searchMore: 'Meer occasions zoeken',
    pageTitle: 'Occasions vergelijken',
    photo: 'Foto',
    emptyState: {
      title: 'Geen voertuigen gekozen',
      desc: "Er zijn (nog) geen voertuigen gekozen om te vergelijken. Zoek een voertuig en klik op 'Vergelijk' om hem toe te voegen.",
      button: 'Occasions zoeken',
    },
  },
  vehicle: {
    mileageUnit: 'km',
    energyPowerUnit: 'kW',
    horsePowerUnit: 'PK',
    type: 'Uitvoering',
    vehicleType: 'Voertuigsoort',
    price: 'Prijs',
    year: 'Bouwjaar',
    mileage: 'Kilometerstand',
    fuelType: 'Brandstof',
    enginePower: 'Vermogen',
    transmission: 'Transmissie',
    license: 'Kenteken',
    body: 'Carrosserie',
    numberDoors: 'Aantal deuren',
    lining: 'Bekleding',
    color: 'Kleur',
    numberCilinders: 'Aantal cilinders',
    sizes: 'Afmetingen',
    engineCapacity: 'Cilinderinhoud',
    engineVolume: 'Motorinhoud',
    engineCapacityUnit: 'cc',
    weight: 'Gewicht',
    maxTowingWeight: 'Max. trekgewicht',
    weightUnit: 'kg',
    volumeUnit: 'L',
    fuelConsumption: 'Verbruik per {amount} km',
    taxMargin: 'BTW/Marge',
    btwMarge: 'BTW/Marge',
    energyLabel: 'Energielabel',
    roadTax: 'Wegenbelasting',
    perQuarterEstimation: 'per kwartaal (schatting)',
    inclTax: 'incl. btw',
    exclTax: 'excl. btw',
    finance: {
      from: 'vanaf',
      privateLeaseFrom: 'Private lease vanaf',
      perMonth: 'p/mnd',
    },
    actions: {
      offer: 'Offerte aanvragen',
      tradeIn: 'Bereken uw inruilwaarde',
      privateLease: 'Private lease aanvragen',
      finance: 'Financiering aanvragen',
      testDrive: 'Proefrit aanvragen',
      callMeBack: 'Bel mij terug',
      buy: 'Nu kopen',
      compare: 'Vergelijken',
      appointment: 'Afspraak maken',
      print: 'Print voertuig',
    },
    warranties: {
      napCheck: 'NAP-Check',
      hundredPercentMaintained: '100% onderhouden',
      carPass: 'Car-Pass',
      bovagDescription:
        'Afhankelijk van het gekozen afleverpakket kunnen onderstaande garanties bij het voertuig worden geleverd. Neem contact op voor informatie over de specifieke afleverpakketten.',
      bovag40: 'BOVAG 40 punten check',
      bovagAfleverbeurt: 'BOVAG Afleverbeurt',
      bovag6months: '6 maanden BOVAG Garantie',
      bovag12months: '12 maanden BOVAG Garantie',
      bovag24months: '24 maanden BOVAG Garantie',
      autotrust: 'Autotrust',
      vakgarant: 'Vakgarant',
      vweOccasionPlan: 'VWE Occasion Garant Plan',
      cargarantie: 'Cargarantie',
      additionalWarrantyButton: 'Bekijk onze garantiebepalingen',
    },
  },
  loop: {
    view: 'Bekijk',
    viewCar: 'Bekijk auto',
    compare: 'Vergelijk',
  },
  single: {
    back: 'Terug naar alle occasions',
    contactTitle: 'Direct contact',
    shareTitle: 'Deel deze auto',
    shareText: 'Bekijk%20deze%20auto%20bij%20',
    route: 'Route',
    email: 'E-mail',
    tabs: {
      specs: 'Specificaties',
      options: 'Opties',
      desc: 'Beschrijving',
      warranty: 'Garantie',
      deliverOptions: 'Afleverpakketten',
    },
    deliverOptions: {
      description: 'Beschrijving',
      price: 'Prijs',
      inclTax: 'incl. btw',
      contents: 'Inhoud',
    },
    warranty: {
      moreInfo: 'Meer informatie',
    },
  },
  filters: {
    title: 'Occasions zoeken',
    modalTitle: 'Zoekfilters instellen',
    modalButton: 'Bekijk resultaten',
    compare: 'Vergelijken',
    filter: 'Filter',
    allBrands: 'Alle merken',
    allModels: 'Alle modellen',
    brand: 'Merk',
    model: 'Model',
    resetFilters: 'Wis filters',
    emptyState: {
      title: 'Niets gevonden',
      desc: 'We konden geen voertuigen vinden die voldoen aan de opgegeven criteria. Pas de filters aan of klik op de knop om opnieuw te beginnen.',
      button: 'Reset alle filters',
    },
    results: '{count} resultaat | {count} resultaten',
  },
  search: {
    inputTitle: 'Zoekterm',
    inputPlaceholder: 'Zoeken...',
    searchIn: 'Zoeken in',
    searchInAll: 'Alle voertuigen',
    searchInSelection: 'Voertuigen uit selectie',
    submit: 'Zoeken',
  },
  sort: {
    relevance: 'Relevantie',
    alphabetically: 'Alfabetisch',
    priceAsc: 'Prijs (laag - hoog)',
    priceDesc: 'Prijs (hoog - laag)',
    dateAddedDesc: 'Datum toegevoegd (nieuw - oud)',
    mileageAsc: 'Kilometerstand (laag - hoog)',
  },
  forms: {
    errors: {
      requiredFields: 'Vul alle verplichte velden in',
      requiredFieldSingle: 'Dit veld is verplicht',
      acceptTerms: 'U dient akkoord te gaan met de voorwaarden',
      validEmail: 'Vul a.u.b. een geldig e-mailadres in',
      noAddressFound: {
        text: 'Het adres kon niet gevonden worden. Heb je de juiste postcode en huisnummer ingevuld?',
        button: 'Handmatig invullen',
      },
      somethingWentWrong: 'Er is iets misgegaan bij het verzenden van de aanvraag. Probeer het later opnieuw.',
    },
    fields: {
      salutation: 'Aanhef',
      salutationMale: 'Dhr.',
      salutationFemale: 'Mevr.',
      fullName: 'Volledige naam',
      name: 'Naam',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      email: 'E-mailadres',
      phone: 'Telefoonnummer',
      address: 'Adres',
      zip: 'Postcode',
      houseNumber: 'Huisnummer',
      houseNumberSupplement: 'Toevoeging',
      city: 'Stad',
      street: 'Straatnaam',
      birthDate: 'Geboortedatum',
      mileage: 'Kilometerstand',
      comments: 'Opmerkingen',
      acceptTermsPre: 'Ik ga akkoord met de',
      terms: 'algemene voorwaarden',
      unknown: 'Onbekend',
      submitRequest: 'Bevestig aanvraag',
      yes: 'Ja',
      no: 'Nee',
      companyName: 'Bedrijfsnaam',
    },
    testRide: {
      title: 'Vraag een proefrit aan',
      preferenceDate: 'Voorkeursdatum proefrit',
      submit: 'Proefrit aanvragen',
    },
    appointment: {
      title: 'Afspraak maken',
      preferenceDate: 'Voorkeursdatum',
      preferenceTime: 'Voorkeurstijd',
      submit: 'Maak afspraak',
    },
    tradeIn: {
      title: 'Bereken inruilwaarde',
    },
    privateLease: {
      title: 'Private lease aanvragen',
      stepCalculator: 'Uw private lease',
      stepPersonalDetails: 'Gegevens',
      stepConfirm: 'Bevestigen',
      leaseAmount: 'Leasebedrag',
      from: 'vanaf',
      perMonth: 'per maand',
      calculationDisclaimer: 'op basis van {mileage} km per jaar en een contractduur van {duration} maanden',
      calculatorTitle: 'Uw private lease samenstellen',
      calculatorDesc:
        'Het leasebedrag is afhankelijk van verschillende factoren. Vraag hier een offerte aan en ontdek uw persoonlijke leasebedrag per maand.',
      duration: 'Gewenste looptijd',
      months: 'maanden',
      mileagePerYear: 'Kilometers per jaar',
      damageFreeYears: 'Aantal schadevrije jaren',
      prepayment: 'Aanbetaling',
      request: 'Aanvragen',
      toConfirmStep: 'Naar bevestigen',
      confirmDesc:
        'Controleer hier uw gegevens en bevestig vervolgens de aanvraag om deze in te dienen. We nemen zo snel mogelijk contact met u op.',
      leaseDetails: 'Lease gegevens',
      personalDetails: 'Persoonlijke gegevens',
      edit: 'wijzigen',
    },
    callMeBack: {
      title: 'Bel mij terug',
      submit: 'Bel mij terug',
    },
    finance: {
      title: 'Financiering aanvragen',
      consumer: 'Particulier',
      business: 'Zakelijk',
      vehiclePrice: 'Aanschafprijs voertuig',
      prepaymentTradeIn: 'Aanbetaling / inruil',
      creditSumLoanAmount: 'Kredietsom / leenbedrag',
      durationInMonths: 'Looptijd in maanden',
      finalSum: 'Slotsom',
      finalSumError: 'Geen slotsom mogelijk, het minimaal te financieren bedrag is',
      monthlyFee: 'Maandbedrag',
      calculationDisclaimer: 'De berekening is gebaseerd op {interestRate}% effectieve rente op jaarbasis.',
      askOffer: 'Offerte aanvragen',
      stepCalculator: 'Uw financiering',
      stepPersonalDetails: 'Gegevens',
      stepConfirm: 'Bevestigen',
      financeDetails: 'Financieringsgegevens',
      confirmDesc:
        'Controleer hier uw gegevens en bevestig vervolgens de aanvraag om deze in te dienen. We nemen zo snel mogelijk contact met u op.',
    },
    offer: {
      title: 'Offerte aanvragen',
      tradeInCar: 'Wilt u een auto inruilen?',
      yourLicense: 'Uw kenteken',
      submit: 'Offerte aanvragen',
    },
    buy: {
      title: 'Auto online kopen',
      stepPersonalDetails: 'Gegevens',
      stepPaymentDelivery: 'Betaalwijze & Levering',
      stepConfirm: 'Bevestigen',
      personalDetailsDesc: 'Heeft u uw droomauto gevonden? Super! Vul hieronder uw gegevens in om de bestelling compleet te maken.',
      consumerOrBusiness: 'Gaat het in dit geval om een particuliere of zakelijke order?',
      consumer: 'Particulier',
      business: 'Zakelijk',
      ownerQuestion: 'Op wiens naam moet de auto geregistreerd worden?',
      ownerSelf: 'Mijn eigen naam',
      ownerOther: 'Andere naam',
      ownerDetails: 'Tenaamstelling',
      driverLicenseCountry: 'Heeft u een Nederlands of buitenlands rijbewijs?',
      dutch: 'Nederlands',
      foreign: 'Buitenlands',
      driverLicenseDisclaimer:
        'Uw rijbewijsnummer en geboortedatum hebben wij nodig voor de tenaamstelling (registratie) van de auto. Rijbewijsnummer niet bij de hand? Geen probleem, dan nemen wij voor aflevering van de auto nog contact met u op.',
      driverLicenseNumber: 'Rijbewijsnummer',
      toPaymentDetails: 'Naar betaalwijze',
      paymentDetails: 'Betaalwijze',
      paymentDetailsDesc: 'Hoe zou u willen betalen, bij aflevering of vooraf? Aan u de keuze.',
      paymentAtDelivery: 'Betalen bij aflevering',
      paymentAtDeliveryDesc: 'U betaalt bij aflevering van de auto via internetbankieren.',
      ideal: 'Betaalverzoek',
      idealDesc: 'U betaalt eenvoudig en veilig met een link die u per e-mail van ons krijgt.',
      bankTransfer: 'Bankoverschrijving',
      bankTransferDesc: 'U betaalt handmatig per bankoverschrijving, de betaalgegevens ontvangt u per e-mail.',
      delivery: 'Aflevering',
      deliveryDesc:
        'Kies hier of u de auto thuis wilt laten afleveren of bij ons komt afhalen. Geef vervolgens een gewenste afleverdatum aan, wij zullen contact met u opnemen om deze te bevestigen.',
      deliveryPackages: 'Afleverpakket',
      deliveryPackagesDesc: 'Geef hieronder aan welk afleverpakket u toe wilt voegen bij uw aankoop.',
      home_delivery: 'Thuis laten afleveren',
      roadside_assistance: 'Pechhulp',
      insurance: 'Verzekering',
      extraOptions: 'Extra opties',
      extraOptionsDesc: 'Voeg eventueel nog extra opties toe bij de aankoop van uw occasion.',
      preferredDeliveryDate: 'Gewenste afleverdatum',
      toConfirm: 'Naar bevestigen',
      confirmDesc: 'Nadat je je gegevens hebt gecontroleerd kun je de aanvraag indienen. We nemen zo snel mogelijk contact met je op.',
      personalDetails: 'Persoonlijke gegevens',
      edit: 'wijzigen',
    },
  },
}

export default translations
